module.exports = __webpack_public_path__ + "static/media/Gosch_Carola-061R13x18_wide.c7b96e1b.jpg";